import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { BASE_URL } from "../utils/constants"
import { Translate } from "../utils/translation"
import SEO from "../components/seo"
import {
  AppCtaDesktopWrapper,
  AppCtaMobileWrapper,
} from "./AppCTABanner/staticDataWrapper"

import Loadable from "@loadable/component"

import Theme from "@airasia/phoenix-components/components/Theme"
import UniversalHeader from "@airasia/phoenix-widgets/widgets/UniversalHeader"
// import AppDownload from "@airasia/phoenix-widgets/widgets/AppDownload"
// import UniversalFooter from "@airasia/phoenix-widgets/widgets/UniversalFooter"
import HeroBanner from "@airasia/phoenix-widgets/widgets/HeroBanner"
import Title from "@airasia/phoenix-components/components/Title"
import Breadcrumb from "../components/breadcrumb"
import thaiFooter from "../data/phoenix/footer-th"
import indoFooter from "../data/phoenix/footer-id"
import UNIVERSAL_HEADER_DATA from "../data/phoenix/universalHeader"
// import UNIVERSAL_HEADER_DATA2 from "../data/phoenix/universalHeader2"
import UNIVERSAL_FOOTER_DATA from "../data/phoenix/universalFooter"
import EMOJI_SCORING_DATA from "../data/phoenix/emojiScoring"

import { GTM_PROJECT_CATEGORY } from "../utils/constants"
import { getGtmUserType, fireGtmEvent } from "../utils/functions"
import WebVitalRUM from "@airasia/phoenix-components/components/WebVitalRUM"
// import { hyphenDelimitedLowerCase } from "../utils/functions"

// const UniversalHeader = Loadable(() =>
//   import("@airasia/phoenix-widgets/widgets/UniversalHeader")
// )
// const AVAChatbot = Loadable(() =>
//   import("@airasia/phoenix-widgets/widgets/AVAChatbot")
// )
const EmojiScoring = Loadable(() =>
  import("@airasia/phoenix-components/components/EmojiScoring")
)
const UniversalFooter = Loadable(() =>
  import("@airasia/phoenix-widgets/widgets/UniversalFooter")
)

const DownloadPageButton = styled.button`
  position: absolute;
  top: 280px;
  right: 55%;
  width: 20%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #555;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  text-align: center;
`

const Wrapper = styled.div`
  max-width: 625px;
  margin: 0px 16px 24px;

  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0px auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0px auto 48px;
  }
`
const EmojiFeedbackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 10px;
  align-items: center;

  @media only screen and (max-width: 768px) {
    margin: 0px 0px 10px;

    #emojiFeedbackTitle {
      margin: 0px 15px 10px;
    }
  }
`

const MobileContainer = styled.div`
  @media only screen and (min-width: 768px) {
    display: none;
  }

  #uhf-placeholder {
    height: 50px;
  }
`

const DesktopContainer = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }

  #uhf-placeholder {
    height: 64px;
  }
`

const Layout = ({ pageData, url, currentURL, location, type, path, countryUrl, countryName, countryCode, children, includeFeedback }) => {
  if (location.toLowerCase() === "city") location = "Malaysia"
  const { faq, heroBanner } = pageData
  console.log("heroBanner",heroBanner)
  const countryURL = `/food/city${countryUrl}`
  let lang = url=== "/th/th/"  || url=== "/id/id/"? countryCode.toLowerCase() : "en"
  let ogLocale = url=== "/th/th/"  || url=== "/id/id/"? countryCode.toLowerCase()+"-"+countryCode : "en-GB"
  let title = `Food Delivery in ${location} | airasia Food`
  let keywords = `unlimited free delivery, free delivery, buy food ${location.toLowerCase()}, home-cooked meal, asian meal, healthy meal, western meal, vegetarian meal, online restaurant, online cafes, online meal, dessert, beverage, drinks, online delivery service, food delivery, food delivery service`
  let description = `Order food delivery in ${location} and satisfy your cravings with so many meal options to choose from. All these delivered at your doorstep! Order now!`
  // const ogImage =
  //   "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food_Delivery_Generic_mobile.jpg"
  let emojiText = ` How would you rate your experience on this page?`
  let emojiMaxText = "Very Satisfied"
  let emojiMinText = "Very Dissatisfied"
  let HeaderData = UNIVERSAL_HEADER_DATA["EN"]
  let labelBreadcrumb = url === "/th/th/" || countryUrl === "/th/th/" ? "อาหาร" : "Food"
  let AppCtaMobile = AppCtaMobileWrapper[
    countryUrl === "/th/th/" || url === "/th/th/" ? "/th/th/" : "/"
  ]
  let AppCtaDesktop = AppCtaDesktopWrapper[
    countryUrl === "/th/th/" || url === "/th/th/" ? "/th/th/" : "/"
  ]
  // console.log("countryUrl",countryUrl)
  // console.log("Translate",Translate)
  let footer_data = UNIVERSAL_FOOTER_DATA
  if (url === "/th/th/" || countryUrl === "/th/th/") {
    title = `สั่งอาหารออนไลน์ใน${location} | จัดส่งไว | แอร์เอเชียฟู๊ด`
    countryName = "ประเทศไทย"
    keywords = `ส่งฟรีไม่จำกัด, ส่งฟรี, สั่งอาหาร ${location.toLowerCase()}, อาหาร home-cooked, อาหารอาเซียน, อาหารเพื่อสุขภาพ, อาหารตะวันตก, อาหารมังสวิรัติ, ร้านอาหารออนไลน์, คาเฟ่ออนไลน์, สั่งอาหารออนไลน์, อาหารว่าง, เครื่องดื่ม, น้ำดื่ม, บริการอาหารออนไลน์, อาหารเดลิเวอรี่, สั่งอาหารเดลิเวอรี่`
    description = `สั่งอาหารออนไลน์จากร้านอาหารใน${location}ผ่านแอร์เอเชียฟู้ด อิ่มอร่อยกับอาหารหลากหลายชนิด สั่งอาหารออนไลน์ง่ายๆ ส่งตรงถึงมือคุณ จัดส่งไวไม่ต้องเสียเวลาต่อคิวอีกต่อไป ให้แอร์เอเชียฟู้ดเดลิเวอรี่อาหารจานโปรดในโซน${location}แทนคุณ สั่งเลย!`
    emojiText = `กรุณาให้คะแนนประสบการณ์การใช้บริการหน้านี้ค่ะ`
    emojiMaxText = `พึงพอใจมาก`
    emojiMinText = `ไม่พึงพอใจ`
    lang = "th"
    ogLocale = "th-TH"
    HeaderData = UNIVERSAL_HEADER_DATA["TH"]
    footer_data = thaiFooter
  }

  if(url === "/id/id/" || countryUrl === "/id/id/"){
    title = `Pesan Makanan di ${location} | airasia food`
    countryName = "Indonesia"
    keywords =
      `airasia food, pesan makanan, aplikasi pesan makanan, aplikasi pesan antar makanan, pesan antar makanan, layanan pesan antar makanan, menu makan siang, menu makanan, menu makan malam`
    description =`Pesan makanan di ${location} lebih mudah dengan airasia food! Nikmati berbagai menu makanan enak di ${location} dan promo menarik eksklusif untuk Anda. Yuk, pesan sekarang!`
    emojiText = `Bagaimana pengalaman Anda di halaman ini?`
    emojiMaxText = `Sangat Puas`
    emojiMinText = `Sangat Tidak Puas`
    lang = "id"
    ogLocale = "id-ID"
    HeaderData = UNIVERSAL_HEADER_DATA["ID"]
    labelBreadcrumb = "Makanan"
    AppCtaMobile = AppCtaMobileWrapper["/id/id/"]
    AppCtaDesktop = AppCtaDesktopWrapper["/id/id/"]
    footer_data = indoFooter
  }
  if(url === "/id/id/"){
    title = `Layanan Pesan Antar Makanan di ${location} | airasia food`
    keywords = `airasia food, pesan makanan, aplikasi pesan makanan, aplikasi pesan antar makanan, pesan antar makanan, layanan pesan antar makanan, menu makan siang, menu makanan, menu makan malam`
    description = "Pesan makanan apa saja lebih mudah dengan airasia food! Nikmati berbagai pilihan makanan dan promo menarik eksklusif untuk Anda. Yuk, cek menu makanan dan pesan sekarang!"
  }

  if(countryUrl === "/id/"){
    title = `Order food online in ${location} | airasia Food`
    keywords = `food online in ${location}, order food in ${location}, food in ${location} `
    description = `Looking for food delivery in ${location}? Order with airasia food we deliver your favourite meals from top restaurants and cafes in ${location} to your door step. Order now!`
  }

  if(url === "/id/"){
    title = `Food Delivery in ${location} | airasia Food`
    keywords = `food delivery ${location}, food in ${location}`
    description = `Get your food delivery in ${location} with just a few clicks and satisfy your cravings with many meal options. All these delivered at your doorstep fast and secure! Order now!`
  }

  if(url === "/sg/" || countryUrl === "/sg/")
    HeaderData = UNIVERSAL_HEADER_DATA["SG"]

  const AA_URL =
    process.env.GATSBY_ENV === "stg" || process.env.GATSBY_ENV === "dev"
      ? "https://www.stgairasia.com"
      : "https://www.airasia.com"
  const breadcrumb =
    type === "country"
      ? [
          {
            label: labelBreadcrumb,
            path: AA_URL + "/food/",
          },
          {
            label: location,
            path:
              location === "Malaysia"
                ? AA_URL + `/food/city/`
                : AA_URL + `/food/city${url}`,
          },
        ]
      : [
          {
            label: labelBreadcrumb,
            path: AA_URL + "/food/",
          },
          {
            label: countryName ? countryName : "City",
            path: AA_URL + countryURL,
          },
          {
            label: location,
            path: AA_URL + `/food/city/${url}/`,
          },
        ]

  // const avaGtmFire = () => {
  //   const obj = {
  //     event: "trackEventNoEcommerce",
  //     "eventDetails.category": `AVA Chat Bot`,
  //     "eventDetails.action": `click`,
  //     "eventDetails.label": `${GTM_PROJECT_CATEGORY} | ${getGtmUserType()}`,
  //   }
  //
  //   fireGtmEvent(obj)
  // }

  const onEmojiClicked = val => {
    const gtmEvent = {
      event: "trackEventNoEcommerce",
      "eventDetails.category": `emoji scoring`,
      "eventDetails.action": `click`,
      "eventDetails.label": `${GTM_PROJECT_CATEGORY} | ${val} | ${getGtmUserType()}`,
    }

    fireGtmEvent(gtmEvent)
  }

  var hreflangCity = countryName !== "Thailand" && countryName !== "Indonesia" ?[
    `<link rel="alternate" hreflang="X-Default" href=${BASE_URL}/${url+"/"} />`,
    `<link rel="alternate" hreflang="en" href=${BASE_URL}/${url+"/"} />`
  ]:[]

  if(countryName === "Thailand"){
    hreflangCity =[
      `<link rel="alternate" hreflang="X-Default" href=${BASE_URL}/${url+"/"} />`,
      `<link rel="alternate" hreflang="en-TH" href=${BASE_URL+"/"}${url.replace("/th","")+"/"} />`,
      `<link rel="alternate" hreflang="th-TH" href=${BASE_URL+"/"}${url.replace("/th","")+"/th/th/"} />`,
    ]
  }
  if(countryName === "Indonesia"){
    hreflangCity =[
      `<link rel="alternate" hreflang="X-Default" href=${BASE_URL}/${url+"/"} />`,
      `<link rel="alternate" hreflang="en-ID" href=${BASE_URL+"/"}${url.replace("/id","")+"/"} />`,
      `<link rel="alternate" hreflang="id-ID" href=${BASE_URL+"/"}${url.replace("/id","")+"/id/id/"} />`,
    ]
  }
  const hrefLang = type === "country"?[ 
  `<link rel="alternate" hreflang="X-Default" href=${BASE_URL+"/"} />`,
  `<link rel="alternate" hreflang="en" href=${BASE_URL+"/"} />`,
  `<link rel="alternate" hreflang="en-SG" href=${BASE_URL+"/sg/"} />`,
  `<link rel="alternate" hreflang="en-TH" href=${BASE_URL+"/th/"} />`,
  `<link rel="alternate" hreflang="th-TH" href=${BASE_URL+"/th/th/"} />`,
  `<link rel="alternate" hreflang="en-ID" href=${BASE_URL+"/id/"} />`,
  `<link rel="alternate" hreflang="id-ID" href=${BASE_URL+"/id/id/"} />`
  ]:hreflangCity

  return location ? (
    <Theme theme="AIRASIA_CLASSIC">
      <SEO
        title={title}
        keywords={keywords}
        description={description}
        ogImage={
          "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food-Delivery-Generic_mobile_new2.jpg"
          // "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/mobile_" +
          // hyphenDelimitedLowerCase(location) +
          // ".jpg"
        }
        url={url}
        faq={faq}
        breadcrumb={breadcrumb}
        lang={lang}
        hrefLangData={hrefLang}
        ogLocale={ogLocale}
        countryURL={countryUrl}
      />
      <WebVitalRUM fireGtm={fireGtmEvent}/>
      <MobileContainer>
        <div id="uhf-placeholder">
          <UniversalHeader
            data={
              url === "/th/th/" || countryUrl === "/th/th/"
                ? UNIVERSAL_HEADER_DATA["TH"]
                : HeaderData
            }
            locale="en-gb"
            currency="MYR"
            environment="production"
            viewport="mobile"
            loginConfig={{
              HideLoginIconForMobile: false,
              enableBigPoints: false,
              reloadOnLoginStatusChange: true,
              shouldSetCookie: false,
            }}
            fireGtm={fireGtmEvent}
          />
        </div>
        <HeroBanner
          bannerDetails={heroBanner}
          device="mobile"
          gtmParameters={{
            event: "trackEventNoEcommerce",
            eventActionClick: "click",
            eventActionView: "view",
            eventCategory: "{{consumername}}|herobannermobile",
            eventLabelCardClick: " {{bannerid}}|{{bannerposition}} ",
            eventLabelHeadlineClick: "",
            eventLabelView: `{{bannerid}}|{{bannerposition}}`,
          }}
          onBannerClick={obj => {
            fireGtmEvent(obj)
          }}
          gtmConsumerName={GTM_PROJECT_CATEGORY}
          fireGtm={fireGtmEvent}
        />
      </MobileContainer>

      <DesktopContainer>
        <div id="uhf-placeholder">
          <UniversalHeader
            data={
              url === "/th/th/" || countryUrl === "/th/th/"
                ? UNIVERSAL_HEADER_DATA["TH"]
                : HeaderData
            }
            locale="en-gb"
            currency="MYR"
            environment="production"
            viewport="desktop"
            loginConfig={{
              HideLoginIconForMobile: false,
              enableBigPoints: false,
              reloadOnLoginStatusChange: true,
              shouldSetCookie: false,
            }}
            fireGtm={fireGtmEvent}
          />
        </div>
        <div>
        <HeroBanner
          bannerDetails={heroBanner}
          device="desktop"
          buttonColor="grey"
          gtmParameters={{
            event: "trackEventNoEcommerce",
            eventActionClick: "click",
            eventActionView: "view",
            eventCategory: "{{consumername}}|herobanner",
            eventLabelCardClick: " {{bannerid}}|{{bannerposition}} ",
            eventLabelHeadlineClick: "",
            eventLabelView: `{{bannerid}}|{{bannerposition}}`,
          }}
          onBannerClick={obj => {
            fireGtmEvent(obj)
          }}
          gtmConsumerName={GTM_PROJECT_CATEGORY}
          fireGtm={fireGtmEvent}
        />
      <DownloadPageButton onclick="location.href='https://airasia.onelink.me/F4uy/0hxr8hu5'">
      Download airasia Superapp
      </DownloadPageButton>
      </div>
      </DesktopContainer>

      <Wrapper>
        {breadcrumb && (
          <div style={{ marginTop: "2%" }}>
            <Breadcrumb crumbs={breadcrumb} />
          </div>
        )}
        {children}
      </Wrapper>

      {includeFeedback && (
        <EmojiFeedbackWrapper>
          <Title
            type="h3"
            customProperties={{
              id: "emojiFeedbackTitle",
            }}
            marginBottom="XXXSmall"
          >
            {emojiText}
          </Title>
          <EmojiScoring
            data={EMOJI_SCORING_DATA}
            fullWidth={false}
            maxText={emojiMaxText}
            minText={emojiMinText}
            onEmojiClicked={onEmojiClicked}
            textColor="greyDark"
            textSize="small"
          />
        </EmojiFeedbackWrapper>
      )}

      <MobileContainer>
        {
          AppCtaMobile
        }
        <UniversalFooter viewport="mobile" data={footer_data} />
      </MobileContainer>

      <DesktopContainer>
        {/* <AppDownload
        accessible
        androidConfig={{
          imageUrl: 'https://a.staticaa.com/images/logo/google-play-badge.png',
          url: 'https://airasia.onelink.me/F4uy/bb759386'
        }}
        customProperties={{}}
        fireGtm={function noRefCheck(){}}
        gtmConsumerName="Test"
        gtmParameters={{
          event: 'trackEventNoEcommerce',
          eventActionClick: 'click',
          eventCategory: '{{consumername}} | Button',
          eventLabelButtonClick: 'Button | {{user}} | {{buttonLabel}}| {{buttonUrl}}'
        }}
        huaweiConfig={{
          imageUrl: 'https://a.staticaa.com/images/logo/huawei-app-gallery-badge.png',
          url: 'https://appgallery.huawei.com/#/app/C100141357?sharePrepath=ag&channelId=appdownload%20page&id=ed8340378fd24f95a75ba333733a6415&s=65873558A5A2C43D4A9B20499A835032C58C68BDBE39B81310ABF4F176EB4C68&detailType=0&v='
        }}
        iosConfig={{
          imageUrl: 'https://a.staticaa.com/images/logo/app-store-badge.png',
          url: 'https://airasia.onelink.me/F4uy/c1f42f37'
        }}
        isMobile={false}
        qrImage="https://a.staticaa.com/images/web-apps/content-pages/library/airasiacom-qrcode.png"
        subtitle=""
        theme="AIRASIA_CLASSIC"
        title="airasia - The Asean Superapp"
      /> */}
        {
          AppCtaDesktop
        }
        <UniversalFooter viewport="desktop" data={footer_data} />
      </DesktopContainer>
    </Theme>
  ) : (
    <></>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

Layout.defaultProps = {
  includeFeedback: true,
}

export default Layout
